import { REDUX_ACTIONS, GAME_ID } from 'a/pickyGoblins/data/constants';

const initState = {
  animation: '',
  isDisabled: false,
};

const goblinReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.GOBLIN_SET_ANIMATION:
      return {
        ...state,
        animation: payload,
      };

    case REDUX_ACTIONS.GOBLIN_SET_DISABLED:
      return {
        ...state,
        isDisabled: payload,
      };

    default:
      return state;
  }
};

export default goblinReducer;
